import classNames, { type Argument } from "classnames";
import { twMerge } from "tailwind-merge";

// Class-merge helper local to the shell Layout primitives, kept free of webapp
// helpers so Layout stays portable for extraction into @circleco/compass.
// Mirrors Compass's `cx`; replaced by the Compass `cx` when Layout moves.
export const cx = (...args: Argument[]): string => twMerge(classNames(args));
